import React from "react";
import { useTheme } from "@mui/material";
import Typography from "../../typography";

export interface TextBoxSelectionOption {
  children?: React.ReactNode;
  label?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const TextBoxSelectionComponent: React.FC<TextBoxSelectionOption> = ({
  children,
  label,
  checked,
  onChange,
  disabled,
}) => {
  const theme = useTheme();

  return (
    <div>
      <div
        style={{
          padding: theme.spacing(0.5),
          backgroundColor: checked ? "#F9A21B" : "#00000000",
          border: `1px solid #000`,
          cursor: "pointer",
          transition: "all 0.5s ease",
          opacity: disabled ? 0.5 : 1,
        }}
        onClick={() => onChange(!checked)}
      >
        <Typography align="center" variant="body2">
          {label}
        </Typography>
      </div>
      {checked && children !== null && <div>{children}</div>}
    </div>
  );
};

export default TextBoxSelectionComponent;
